// extracted by mini-css-extract-plugin
export default {"l":"StandList_l__dhu72"};